<template>
  <div class="answer-wrapper" v-if="answer.slug">
    <div class="core">
      <h1 class="lead-question">{{ answer.name }}</h1>
      <p class="lead-answer">{{ answer.byline }}</p>
      <div class="faq-wrap">
        <article>
          <h2>Top questions asked</h2>
          <div class="faq-list">
            <div v-for="faq in answer.faqs" :key="faq.slug" class="faq-card">
              <h3>{{ faq.name }}</h3>
              <p>{{ faq.body }}</p>
            </div>
          </div>
        </article>
      </div>
    </div>

    <aside>
      <section class="aside-section stories">
        <div class="stories-heading">
          <h3>Dive deeper</h3>
        </div>
        <div class="inner-stories">
          <div class="story" v-for="story in answer.stories" :key="story.slug">
            <router-link :to="`/story/${story.slug}`" class="story-link">
              <div class="story-content-wrapper">
                <div class="story-content">
                  <h4 v-if="story.name" class="story-name">{{ story.name }}</h4>
                  <div class="story-meta-wrapper">
                    <span class="story-meta">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.7812 6.5C11.7812 7.90067 11.2248 9.24398 10.2344 10.2344C9.24398 11.2248 7.90067 11.7812 6.5 11.7812C5.09933 11.7812 3.75602 11.2248 2.76559 10.2344C1.77517 9.24398 1.21875 7.90067 1.21875 6.5C1.21875 5.09933 1.77517 3.75602 2.76559 2.76559C3.75602 1.77517 5.09933 1.21875 6.5 1.21875C7.90067 1.21875 9.24398 1.77517 10.2344 2.76559C11.2248 3.75602 11.7812 5.09933 11.7812 6.5ZM0 6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.68482 8.22391 0 6.5 0C4.77609 0 3.12279 0.68482 1.90381 1.90381C0.68482 3.12279 0 4.77609 0 6.5ZM5.89062 3.04688V6.5C5.89062 6.70312 5.99219 6.89355 6.1623 7.00781L8.5998 8.63281C8.8791 8.8207 9.25742 8.74453 9.44531 8.4627C9.6332 8.18086 9.55703 7.80508 9.2752 7.61719L7.10938 6.175V3.04688C7.10938 2.70918 6.8377 2.4375 6.5 2.4375C6.1623 2.4375 5.89062 2.70918 5.89062 3.04688Z" fill="black"/>
                      </svg>
                      {{ story.last_published_at | ago }}
                    </span>
                    <div class="item-mood" :class="getMood(story.mood).code">
                      <div class="item-mood-marker"></div>
                      <span>{{ getMood(story.mood).name }}</span>
                    </div>
                  </div>
                </div>

                <div onerror="this.style.display='none'" class="inner-image">
                  <img :src="story.image" :alt="story.name" />
                </div>
              </div>

              <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>
            </router-link>
          </div>
        </div>

      </section>
      <!-- <router-link :to="`/story/${story.slug}`" v-for="story in answer.stories" :key="story.slug" :story="story" class="story">
        <img :src="story.image"/>
        <div class="story-content">
          <h4>{{ story.name }}</h4>
          <p>{{ story.synopsis }}</p>
        </div>
      </router-link> -->
    </aside>
  </div>
  <div v-else class="loader-container">
    <data-loading />
  </div>
</template>

<script>
  import API from 'app/axios';
  import DataLoading from '@/components/_v5/grid-sections/DataLoading';

  export default {
    name: 'Answers',
    data() {
        return {}
    },
    mounted () {
      if (this.slug) {
        API.getAnswers(this.slug);
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },

    computed: {
      slug() {
        return this.$route.params.slug;
      },
      answer() {
        return this.$store.getters.getAnswer(this.slug);
      }
    },

    methods: {
      getMood(mood) {
        if (mood < -0.25) {
          return {
            code: 'negative',
            name: 'Negative'
          }
        } else if (mood > 0.25) {
          return {
            code: 'positive',
            name: 'Positive'
          }
        }

        return {
          code: 'neutral',
          name: 'Neutral'
        }
      },
    },

    components: {
      DataLoading,
    },
  }
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/v5.scss';

.answer-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  // padding: 2rem 1rem;
  // padding-bottom: 5em;
  display: grid;
  height: $desktop-grid-height;
  grid-template-columns: $desktop-grid-main $desktop-grid-aside;
  border-left: 1px solid rgba($neutral-400, 0.25);
  border-right: 1px solid rgba($neutral-400, 0.25);
  
  @media (max-width: 950px) {
    grid-template-columns: 1fr;
    height: auto;
  }

  .core {
    height: $desktop-grid-height;
    padding: 2rem;
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 950px) {
      padding: 2rem 1rem;
      height: auto;
      grid-row: 1;
    }

    h1 {
      font-size: 2.8rem;
      font-family: 'Brawler';
      margin-bottom: 2rem;
      font-weight: normal;
    }

    .lead-answer {
      font-size: 1rem;
      margin: 1rem 0 2rem 0;
      padding-bottom: 1.7rem;
      border-bottom: 1px solid rgba($neutral-400, 0.25);
    }

    .faq-wrap {
      font-family: 'Colfax';
      margin-top: 2rem;

      h2 {
        font-family: 'Colfax';
        font-size: 1.2rem;
        font-weight: bold;
        margin-bottom: 1rem;
      }

      .faq-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;

        @media (max-width: 510px) {
          grid-template-columns: 1fr;
        }

        .faq-card {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 1.5rem;
          border-radius: 10px;
          background: rgba($neutral-400, 0.05);

          h3, p {
            font-family: 'Colfax';
            font-size: 1rem;
            line-height: 140%;
          }

          p {
            line-height: 150%;
          }
        }
      }
    }
  }

  aside {
    border-left: 1px solid rgba($neutral-400, 0.25);
    height: $desktop-grid-height;
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 950px) {
      grid-row: 2;
      height: auto;
    }

    .aside-section {
      position: relative;
      padding: 1.5rem;
      border-bottom: 1px solid rgba($neutral-400, 0.25);

      @media (max-width: 820px) {
        border-top: 1px solid rgba($neutral-400, 0.25);
        border-bottom: 0;
        padding: 1rem;
      }
    }

    .stories {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0;
      overflow-y: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        display: none;
      }

      .inner-stories {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 2rem 1.5rem 2rem 1.5rem;

        @media (max-width: 820px) {
          padding: 1rem;
        }
      }

      .stories-heading {
        position: sticky;
        top: 0;
        padding: 2rem 2rem 1.5rem 2rem;
        border-bottom: 1px solid rgba($neutral-400, 0.25);
        backdrop-filter: blur(10px);
        background: rgba($neutral-600, 0.8);

        .darkmode & {
          background: rgba($neutral-100, 0.8);
        }

        @media (max-width: 820px) {
          padding: 1.5rem 1rem 1rem 1rem;
        }

        h3 {
          font-family: 'Brawler';  
          font-weight: normal;
          font-size: 1.4rem;
          margin-bottom: 0.5rem;
        }
      }

      .story-link {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: 1rem 1rem 1rem 1rem;
        gap: 0.75rem;
      }

      .story-content-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }

      .story {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        background: rgba($neutral-400, 0.05);
        border-radius: 10px;
        color: $neutral-100;
        border-left: 2px solid transparent;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        .darkmode & {
          color: $neutral-600;
        }

        &:hover {
          background: rgba($neutral-400, 0.15);
        }

        .story-image {
          width: auto;
        }

        .inner-image {
          width: 4rem;
          height: 4rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 6px;
          }
        }

        .item-mood {
          display: flex;
          align-items: center;
          gap: 0.3rem;
          background: none;
          padding-top: 1px;

          .item-mood-marker {
            width: 7px;
            height: 7px;
            border-radius: 500px;
          }

          span {
            display: inline-block;
            font-size: 0.8rem;
            color: $neutral-400;
            padding-bottom: 1px;
          }

          &.positive {
            color: $green-tone-3;
            .item-mood-marker {
              background: $green-tone-3;
            }
          }

          &.neutral {
            color: $blue-tone-3;
            .item-mood-marker {
              background: $blue-tone-3;
            }
          }

          &.negative {
            color: $red-tone-3;
            .item-mood-marker {
              background: $red-tone-3;
            }
          }
        }

        .story-content {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
          flex: 1;

          .story-name {
            font-size: 1.1rem;
            line-height: 140%;
          }

          .story-meta-wrapper {
            display: flex;
            align-items: center;
            margin-bottom: 0.25rem;

            .story-meta {
              display: flex;
              align-items: center;
              font-size: 0.8rem;
              color: $neutral-400;

              svg {
                margin-top: 1px;
                margin-right: 0.3rem;
                
                path {
                  fill: $neutral-400;
                }
              }

              &:not(:last-child) {
                &::after{
                  content: '|';
                  margin: 0 0.4rem;
                  color: $neutral-400;
                }
              }
            }
          }
        }

        .story-stack {
          font-size: 0.8rem;
          color: $neutral-400;
          line-height: 140%;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .meta {
          display: flex;
          flex-wrap: wrap;
          font-size: 0.8rem;
          gap: 0.5rem;
          padding-bottom: 0.5rem;

          li {
            color: $neutral-400;
            border-bottom: 1px solid $neutral-400;
            padding-bottom: 2px;
            transition: all 0.2s ease-in-out;

            &:hover {
              color: $neutral-100;
              border-bottom: 1px solid $neutral-100;

              .darkmode & {
                color: $neutral-600;
                border-bottom: 1px solid $neutral-600;
              }
            }
          }
        }
      }

      .story-image {
        width: 100%;
      }

      .inner-image {
        width: 100%;
        height: 10rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
      }
    }
  }



  // h2 {
  //   font-size: $fs-screen-heading * 1.5;
  //   font-weight: bold;
  //   text-decoration: underline $yellow-tone-3 3px;
  //   margin-bottom: 1em;
  // }

  // .lead-answer {
  //   border-left: .25em solid $yellow-tone-3;
  //   background: $yellow-tone-1;
  //   color: $yellow-tone-7;
  //   padding: 1em;
  //   margin: 2em 0em;
  //   border-radius: .5em;

  //   .darkmode & {
  //     background: $yellow-tone-7;
  //     color: $yellow-tone-1;
  //   }
  // }

  // .faq-wrap {
  //   @media (max-width: $large-mobile) {
  //     flex-direction: column;
  //   }
  //   display: flex;
  //   gap: 1em;

  //   article {

  //     .faq-list {
        
  //       @media (min-width: $large-mobile) {
  //         columns: 2;
  //       }

  //       .faq-card {
  //         break-inside: avoid;
  //         h3 {
  //           margin-bottom: 1em;
  //         }
  //         p {
  //           color: $neutral-400;
  //           margin-bottom: 1em;
  //         }
  //       }
  //     }
  //   }

  //   aside {
  //     flex-basis: 250px;
  //     .story {
  //       margin-bottom: 1em;
        
  //       border: 1px solid $neutral-500;
  //       .darkmode & {
  //         border: 1px solid $neutral-300;
  //       }

  //       border-radius: .5em;
  //       overflow: hidden;
  //       display: block;

  //       img {
  //         @media (max-width: $large-mobile) {
  //           max-width: 100%;
  //         }
  //         max-width: 250px;
  //       }

  //       .story-content {
  //         margin: .5em;
  //         h4 {
  //           margin-bottom: .5em;
  //         }
  //         p {
  //           @include typo-size-small;
  //         }
  //       }
  //     }
  //   }
  // }
}

// .loader-container {
//   height: 90vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }
</style>